import { useState } from 'react'
import Barcode from 'react-barcode'

import PlainButton from 'app/common/ui-next/plain-button'

import { BarCodeModal } from './BarCodeModal'
import styles from './DishesTableBarCode.module.scss'

export const DishesTableBarCode = ({ title, locked }: { title: string; locked?: boolean }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={styles.root}>
      <div>
        <Barcode
          value={'001237462877412'}
          width={1}
          height={30}
          displayValue={false}
          background="transparent"
          margin={0}
        />
      </div>
      <div>001237462877412</div>
      {!locked && (
        <PlainButton className={styles.button} onClick={() => setIsOpen(true)}>
          {'+'}
        </PlainButton>
      )}
      {isOpen && !locked && <BarCodeModal title={title} onClose={() => setIsOpen(false)} />}
    </div>
  )
}
